import { Widgets } from '@rjsf/mui';
import type { ReactElement } from 'react';

export function SelectWidget(props: Parameters<typeof Widgets.SelectWidget>[0]): ReactElement {
  return <Widgets.SelectWidget {...props} hideLabel />;
}
